import axios from "axios"

const HEADER = (params) => {

    for (let propName in params) {
        if (params[propName] === null || params[propName] === undefined || !params[propName]) {
            delete params[propName];
        }
    }

    const headers = {'Content-Type': 'application/json', 'Accept': 'application/json'}
    const parameters = (params) && params
    return {headers: headers, params: parameters}
}

const URL = (endPoint) => {
    const url = process.env.REACT_APP_APIURL
    return (endPoint) ? url + "/" + endPoint : url
}

export function _get(table, params) {
    return axios.get(URL(table), HEADER(params))
        .then(response => response.data);
}

export function _getShow(table, id) {
    return axios.get(URL(table + "/" + id), HEADER())
        .then(response => response.data);
}

export function _put(table, data) {
    return axios.put(URL(table), data, HEADER())
        .then(response => response.data);
}

export function _patch(table, id, data) {
    return axios.patch(URL(table + "/" + id), data, HEADER() )
        .then(response => response.data);
}

export function _delete(endPoint, id) {
    return axios.delete(URL(endPoint + "/" + id), HEADER())
        .then(response => response.data);
}

export function _postDelete(table, data) {
    return axios.post(URL(table), data, HEADER())
        .then(response => response.data);
}

export function _post(table, data) {
    return axios.post(URL(table), data, HEADER())
        .then(response => response.data);
}

export function _getFields(table) {
    return axios.get(URL(table + '/fields'), HEADER())
        .then(response => response.data);
}